import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import InputDate from "../../atoms/InputDate/InputDate";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Tenth = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.last_vaccination_date);
  }, [formData.last_vaccination_date, onValidationChange]);

  return (
    <InputDate
      label={t("animalInfo:QUESTION_TEN.LAST_VACCIN")}
      value={formData.last_vaccination_date ? dayjs(formData.last_vaccination_date) : null}
      onChange={(value) =>
        setFormData({
          ...formData,
          last_vaccination_date: value?.toISOString(),
        })
      }
      minDate={formData.birth_date ? dayjs(formData.birth_date) : undefined}
    />
  );
};

export default Tenth;
